import { useQuery } from '@tanstack/react-query'

import { listEnrollmentPeriods } from '../../infra/api/enrollment-periods.api'
import type { ListEnrollmentPeriodsDto } from '../../infra/api/enrollment-periods.dto'
import { ENROLLMENT_PERIODS_QUERY_KEYS } from '../../infra/react-query/enrollment-periods.query-keys'

// EMS-10557: every valid enrollment period for the Open Enrollment page drop-down.
export function useListEnrollmentPeriodsQuery(
  companyId: string | undefined,
  options: { enabled?: boolean } = {}
) {
  const { enabled = true } = options
  return useQuery<ListEnrollmentPeriodsDto, Error>({
    queryKey: ENROLLMENT_PERIODS_QUERY_KEYS.list(companyId ?? ''),
    queryFn: () => listEnrollmentPeriods(companyId ?? ''),
    enabled: Boolean(companyId) && enabled,
  })
}
